
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SLink',
  components: {},
  props: {
    label: {
      required: false,
      type: String,
      default: '',
    },
  },

  setup(props, { attrs }) {
    const classes = computed(() => {
      let result = 's-link ';
      return result;
    });

    return { classes };
  },
});
